import { useState } from 'react';
// A drag of files from outside the page, such as photos from the desktop, rather than text or a
// photo's reorder handle within it.
const carriesFiles = (e) => e.dataTransfer.types.includes('Files');
// Takes the files dropped on an element: spread `dropProps` on it, and `isOver` says files are being
// dragged over it. While `disabled`, the element refuses a drop, so the browser neither takes the
// files nor opens them in place of the page.
export const useFileDrop = (onFiles, disabled = false) => {
    const [isOver, setIsOver] = useState(false);
    const dropProps = {
        onDragOver: (e) => {
            if (!carriesFiles(e))
                return;
            e.preventDefault();
            e.dataTransfer.dropEffect = disabled ? 'none' : 'copy';
            setIsOver(true);
        },
        // Leaving for one of its own children is still over it.
        onDragLeave: (e) => {
            if (e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget))
                return;
            setIsOver(false);
        },
        onDrop: (e) => {
            if (!carriesFiles(e))
                return;
            e.preventDefault();
            setIsOver(false);
            if (!disabled)
                onFiles(Array.from(e.dataTransfer.files));
        },
    };
    return { isOver, dropProps };
};
